import { FC, PropsWithChildren, ReactElement } from 'react'

import './FilterSection.scss'

interface FilterSectionProps extends PropsWithChildren {
    className?: string;
}

const FilterSection: FC<FilterSectionProps> = ({
    className = '',
    children,
}): ReactElement => (
    <div className={`filter-section ${className}`}>
        {children}
    </div>
)

export default FilterSection
